<template>
  <div>
    <LoadingState
      v-if="!defaultLang"
      :loading="true"
    />
    <v-container
      v-else
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
        class="mt-3"
      >
        <!-- Toolbar Navigation -->
        <v-toolbar
          flat
          color="transparent"
          class="mb-4 mt-4"
          height="20px"
        >
          <v-btn
            icon
            class="text--secondary"
            @click="goBack"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span class="text-capitalize subheading text--secondary">
            {{ $t('Settings') }}
          </span>
        </v-toolbar>
        <v-flex
          xs12
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md4
              offset-md1
            >
              <h3 class="title font-weight-regular pt-3">
                {{ $t('Default Language') }}
              </h3>
              <p class="caption">
                {{ $t('Default store language selection') }}
              </p>
              <p class="caption">
                {{ $t('Default language determines in what language base attributes of products, shipping methods and others are defined.') }}
              </p>
              <p class="caption">
                {{ $t('Changing default language to different one will not swap translations for all entities on the store.') }}<br>
                {{ $t('This change will only determine in what language current attributes are defined leaving them always as default.') }}<br>
                {{ $t('For example, when original default language was set to English and it will be changed to Spanish, all the entities will remain with base attributes in English and will require to be changed to Spanish.') }}<br>
              </p>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-card
                flat
                class="pa-3"
              >
                <v-select
                  v-if="languagesList.length"
                  v-model="defaultLanguage"
                  :items="languagesList"
                  :label="$t('Default Language')"
                  :return-object="false"
                  item-text="name"
                  item-value="code"
                />
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="mt-3"
      >
        <v-flex
          xs12
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md4
              offset-md1
            >
              <h3 class="title font-weight-regular pt-3">
                {{ $t('Languages') }}
              </h3>
              <span
                class="caption"
              >
                {{ $t('List of languages available for translations') }}
              </span>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-card
                flat
                class="pa-3"
              >
                <languages-list/>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import ImageUpload from '@/components/ImageUpload'
import LanguagesList from '@/modules/Settings/components/LanguagesList'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SettingsLanguages',

  components: {
    LanguagesList,
    ImageUpload,
    LoadingState
  },

  data () {
    return {
      progress: false,
      languages: []
    }
  },

  computed: {
    ...mapGetters(['defaultLang', 'languagesList']),

    defaultLanguage: {
      set (value) {
        const settings = this.$http.make('settings', { data: value })
        settings.code_url = 'general/locale/language'

        settings.save().then(() => {
          this.setDefaultLang(value)
          this.$toast.success(this.$t('Default language saved'))
        }).catch(() => {
          this.$toast.error(this.$t('Failed to save default language'))
        })
      },
      get () {
        if (!this.defaultLang) {
          return ''
        }
        return this.defaultLang.code || ''
      }
    }
  },

  methods: {
    ...mapActions(['setDefaultLang']),

    goBack () {
      this.$router.push({ name: 'settings' })
    }
  }
}
</script>
